<template>
  <div class="main-processes">
    <my-header
      :page_name="$t('navigation.headerTitles.processes')"
      show_usermenu
    ></my-header>
    <div class="settings-line">
      <div class="settings-element">
        <label>{{ $t('processes.server') }}</label>
        <el-select v-model="serverSelected" @change="serverChanged" filterable>
          <el-option
            v-for="(server, index) in getServersArray"
            :key="index"
            :value="server.id"
            :label="server.name"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="buttons-grid between" v-if="!!serverSelected">
      <!-- <el-button class="el-icon-">Скачать</el-button> -->
      <div style="display: flex">
        <div>
          <el-tooltip
            effect="light"
            :content="$t('processes.stop')"
            placement="bottom-start"
          >
            <span>
              <el-button
                style="margin-top: 6px"
                @click="stopProcessClick"
                class="stop-button el-icon-switch-button"
                :disabled="buttonDisabled"
                type="danger"
              ></el-button>
            </span>
          </el-tooltip>
        </div>

        <div>
          <el-dropdown trigger="click">
            <el-button type="plain" size="small" style="margin-top: 2px">
              {{ $t('processes.view') }}
              <i class="el-icon-arrow-down"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="optimalViewBtn"
                >{{ $t('processes.compact') }}</el-dropdown-item
              >
              <el-dropdown-item @click.native="fullViewBtn"
                >{{ $t('processes.full') }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="text-buttons" :class="timerClass">
        <el-button @click="downloadClick" class="el-icon-download left"
          >{{ $t('processes.saveFile') }}</el-button
        >
        <el-button
          @click="autoUpdateClick"
          :class="autoUpdateIcon"
          class="left timer-button"
          >{{ autoUpdateText }}</el-button
        >
      </div>
    </div>
    <!-- чтобы не было пустой полосы при невыбранном сервере -->
    <div v-else class="buttons-grid" style="padding-top: 5.2px"></div>
    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-smaller">
        <ag-grid-vue
          v-if="!!getProcessesArray && !!serverSelected"
          style="
            width: 100%;
            height: 100%;
            font-family: 'Open Sans', sans-serif;
          "
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="getProcessesArray"
          :defaultColDef="defaultColDef"
          :localeText="agGridlocaleText"
          rowSelection="single"
          suppressCellSelection
          @grid-ready="onGridReady"
          @first-data-rendered="onGridFirstDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @column-resized="onColumnResized"
          @rowSelected="onRowSelected"
          @row-data-changed="onGridDataChanged"
        ></ag-grid-vue>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Header from "../../components/reusable/header/Header";
import { mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
export default {
  data() {
    const timerTime = 30;
    return {
      autoUpdateTimer: timerTime,
      gridData: null,
      columnDefs: null,
      defaultColDef: null,
      gridApi: null,
      columnApi: null,
      agGridlocaleText: null,
      settings: null,
      currentRowSelected: null,
      buttonDisabled: true,
      serverSelected: null,
      autoUpdateIcon: "el-icon-video-play",
      autoUpdateText: this.$t('processes.autoRefresh'),
      autoUpdateSecShow: timerTime,
      timerClass: "no-timer",
      timeoutId: null,
      pid: null,
      firstRenderFlag: false,
    };
  },
  methods: {
    serverChanged() {
      this.$store.commit("setLoading", true);
      this.$localStorage.set(
        "wa-processes",
        JSON.stringify(this.serverSelected)
      );
      this.$store
        .dispatch("getProcesses", this.serverSelected)
        .then(() => {
          if (this.getProcessesArray.length === 0) {
            this.$store.commit("setLoading", false);
          }
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    stopProcessClick() {
      this.$confirm(
        this.$t('processes.thisActionStopProcessWantToContinue'),
        this.$t('processes.attention'),
        {
          confirmButtonText: "OK",
          cancelButtonText: this.$t('processes.cancel'),
          type: "warning",
        }
      )
        .then(() => {
          this.$store.commit("setLoading", true);
          return this.$store.dispatch("stopTtyProcess", {
            serverID: this.serverSelected,
            pid: this.pid,
          });
        })
        .then(() => {
          return this.$store.dispatch("getProcesses", this.serverSelected);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
    downloadClick() {
      // //console.log(this.getProcessesArray);

      const rowCount = this.gridApi.getDisplayedRowCount();
      let array = [];
      for (let i = 0; i < rowCount; i++) {
        let rowNode = this.gridApi.getDisplayedRowAtIndex(i);
        // //console.log(rowNode.data);
        // //console.log(Object.values(rowNode.data));

        array.push([
          `"${rowNode.data.app}"`,
          `"${rowNode.data.db}"`,
          `"${rowNode.data.lstart}"`,
          `"${rowNode.data.etime}"`,
          `"${rowNode.data.pcpu}"`,
          `"${rowNode.data.ip}"`,
          `"${rowNode.data.user}"`,
        ]);
      }
      //console.log(array);
      let csvContent = "data:text/csv;charset=utf-8,";
      array.forEach((rowArray) => {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
      });
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "processes.csv");
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv".
    },
    autoUpdateClick() {
      if (this.autoUpdateIcon === "el-icon-video-play") {
        //если таймер не был запущен
        this.timerClass = "with-timer";
        this.autoUpdateIcon = "el-icon-video-pause";
        //console.log("text: ", this.autoUpdateText);
        function run() {
          this.autoUpdateSecShow--;
          //console.log("seconds: ", this.autoUpdateSecShow);
          this.autoUpdateText = this.autoUpdateSecShow + this.$t('processes.sec');
          if (this.autoUpdateSecShow === 0) {
            //если таймер закончился и нужно обновлять страницу
            this.$store.commit("setLoading", true);
            this.timerClass = "upd-timer";
            this.autoUpdateText = this.$t('processes.refresh');
            this.$store
              .dispatch("getProcesses", this.serverSelected)
              .then(() => {
                //console.log("UPDATED", this.autoUpdateTimer);
                this.$store.commit("setLoading", false);
                this.autoUpdateSecShow = this.autoUpdateTimer;
                this.timerClass = "with-timer";
              })
              .catch(() => {
                this.$store.commit("setLoading", false);
              });
          }
          this.timeoutId = setTimeout(run.bind(this), 1000);
        }
        setTimeout(run.bind(this));
      } else {
        //console.log("Stopping timeout", this.timeoutId);
        this.timerClass = "no-timer";
        this.autoUpdateIcon = "el-icon-video-play";
        this.autoUpdateText = this.$t('processes.autoRefresh');
        this.autoUpdateSecShow = this.autoUpdateTimer;
        clearTimeout(this.timeoutId);
      }
    },
    optimalViewBtn() {
      this.gridApi.sizeColumnsToFit();
      this.settings.grids.packs.viewFull = false;
    },
    fullViewBtn() {
      let allColumnIds = [];
      this.columnApi
        .getAllColumns()
        .forEach((column) => allColumnIds.push(column.colId));
      this.columnApi.autoSizeColumns(allColumnIds);
      this.settings.grids.packs.viewFull = true;
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.setEnableCellTextSelection(true);
    },
    onGridDataChanged() {
      if (this.firstRenderFlag) this.$store.commit("setLoading", false);
    },
    onGridSizeChanged(params) {
      params.api.sizeColumnsToFit();
      // this.autoSizeAll();
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onGridFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
      this.$store.commit("setLoading", false);
      this.firstRenderFlag = true;
    },
    onRowSelected(params) {
      //console.log(params);
      if (params.node.selected) {
        this.currentRowSelected = params.node.data; // текущая выбранная строка грида запоминается в буфере
        this.pid = this.currentRowSelected.pid;
        //console.log("CURRENT ROW: ", this.currentRowSelected);
        this.buttonDisabled = false;
      }
    },
  },
  created() {
    this.$store.dispatch("getServers").then(() => {
      let serv = JSON.parse(this.$localStorage.get("wa-processes"));
      if (serv) {
        if (!this.getServersArray.find((s) => s.id === serv)) {
          this.$store.commit("setLoading", false);
          return;
        }
        this.serverSelected = serv;
        this.serverChanged();
      } else this.$store.commit("setLoading", false);
    });
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }
    this.columnDefs = [
      { headerName: i18n.t("tableHeaders.process.app"), field: "app" },
      { headerName: i18n.t("tableHeaders.process.db"), field: "db" },
      {
        headerName: i18n.t("tableHeaders.process.lstart"),
        field: "lstart",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.process.etime"),
        field: "etime",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.process.pcpu"),
        field: "pcpu",
        cellClass: "center-column",
      },
      {
        headerName: i18n.t("tableHeaders.process.ip"),
        field: "ip",
        cellClass: "center-column",
      },
      { headerName: i18n.t("tableHeaders.process.user"), field: "user" },
    ];
    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      autoHeight: true,
    };
    this.settings = {
      grids: {
        packs: {
          viewFull: false,
        },
      },
    };
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },
  computed: {
    ...mapGetters(["getProcessesArray", "getServersArray"]),
  },
  components: {
    myHeader: Header,
    AgGridVue,
  },
};
</script>

<style scoped>
.no-timer {
  margin-right: -38px;
}
.with-timer {
  margin-right: -30px;
}
.upd-timer {
  margin-right: -38px;
}
.with-timer .el-button.timer-button {
  width: 100px;
}
.upd-timer .el-button.timer-button {
  width: 180px;
}
</style>